<div class="homework-wrapper">
    <!-- Teacher view-->
    @if (isTeacher) {
        @if (isLoggedIn || isDigi4SchoolUser || bookAccessCode || applicationStateService.bookConfig.bookPermissions.quickLinks.view) {
            <div class="form-wrapper">
                <homework-form></homework-form>
            </div>
        }
        @if (loading) {
            <img [src]="'spinner-grey-lg.svg' | asset" alt="Wird geladen..." class="spinner"/>
        }
        @if (!homeworkService.isHomeworkEditorOpened() && !loading) {
            @if (homeworks?.length > 0) {
                <ul class="homework-list">
                    @for (hw of homeworks; track hw) {
                        <li>
                            <sidebar-homework-item [homework]="hw"></sidebar-homework-item>
                        </li>
                    }
                </ul>
            }
            @if (homeworkTeamTeaching?.length > 0) {
                <p class="team-teaching">Teamteaching-Aufgaben:</p>
                <ul class="homework-list">
                    @for (hw of homeworkTeamTeaching; track hw) {
                        <li>
                            <sidebar-homework-item [foreign]="true" [homework]="hw"></sidebar-homework-item>
                        </li>
                    }
                </ul>
            }
            <p class="homework-list-info">Es werden die zuletzt erstellten Tests und Aufgaben angezeigt.</p>
        }
    }

    <!-- Student view-->
    @if (!isTeacher) {
        @if (applicationStateService.userData.bookAccessCode && !homeworkService.isHomeworkEditorOpened()) {
            <h3 [class.student]="!applicationStateService.userData.isTeacher">{{ 'hsm.studentForeignHomeworks' | translation : applicationStateService.bookConfig.publisherText }}</h3>
            @if (!homeworkUsed || homeworkUsed.length === 0) {
                <div class="note">
                    <p style="margin-top: 20px"><i class="fas fa-link"></i><span>Von deiner Lehrperson bekommst du den Link zur Aufgabe.</span>
                    </p>
                    <p><span>Geöffnete Aufgaben werden hier aufgelistet.</span></p>
                </div>
            }
            @if (homeworkUsed?.length > 0) {
                <ul class="homework-list">
                    @for (hw of homeworkUsed; track hw) {
                        <li>
                            <sidebar-homework-item [foreign]="true" [homework]="hw"></sidebar-homework-item>
                        </li>
                    }
                </ul>
            }
        }
        @if (!homeworkService.isHomeworkEditorOpened()) {
            <h3
                    [class.student]="!applicationStateService.userData.isTeacher">{{ 'hsm.studentOwnHomeworks' | translation : applicationStateService.bookConfig.publisherText }}</h3>
        }
        @if (isLoggedIn || isDigi4SchoolUser || bookAccessCode || applicationStateService.bookConfig.bookPermissions.quickLinks.view) {
            <div class="form-wrapper">
                <homework-form></homework-form>
            </div>
        }
        @if (!homeworkService.isHomeworkEditorOpened()) {
            @if (homeworks?.length > 0) {
                <ul class="homework-list">
                    @for (hw of homeworks; track hw) {
                        <li>
                            <sidebar-homework-item [homework]="hw"></sidebar-homework-item>
                        </li>
                    }
                </ul>
            }
        }
    }
</div>
